import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Card } from 'react-bootstrap';
import styles from '../../src/assets/styles/Menu.module.scss';


const Menu = ({ menuCategories }) => {

    return (
        <Container fluid className={`${styles.menu} py-5`}>
            <Row>
                {menuCategories.map((category, index) => {

                    const colored = index % 2 === 0 ? styles.colored : ""; // Předpokládám, že máte definovanou třídu 'colored' v souboru SCSS


                    return (

                        <Col sm lg={4} md={6} key={index} className='g-0'>
                            <Card className={`h-100 rounded-0 ${colored}`}>
                                <Card.Body className='p-4'>
                                    <Card.Title>
                                        {category.title}
                                    </Card.Title>
                                    <Card.Text>
                                        <Table hover size="sm">
                                            <tbody>
                                                {category.items.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td>{item.title}</td>
                                                        <td>{item.price}&nbsp;Kč</td>
                                                        <td>{item.description}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>

                    );
                })}
            </Row>
        </Container>
    );
};

export default Menu;
